// extracted by mini-css-extract-plugin
export default {"-large":"KnpJYIzkcXf_goa5NoKR","container":"kr3nPKqJzmOmb9ZEhRem","gap":"jp56ISrEY8I6g3V6XWkl","optionsContainer":"k6lAcVRDtEDabOrwR9JP","animationContainer":"c1Liuk0aaCzjGKYUDbiS"};